import React from "react"
import ReactDOM from "react-dom"

import { CrossIcon } from "client/components"
import {
    BalloonMessageWrapper,
    Message,
    MessageBody,
    MessageClose,
} from "./styled"

interface ParamsType {
    height: number
    translate: number
}

// eslint-disable-next-line import/prefer-default-export
export const BalloonMessage = (text: string) => {
    const layout = document.body

    const updateMessagePosition = () => {
        const messages = layout.querySelectorAll(BalloonMessageWrapper)
        let params: ParamsType = {
            height: 0,
            translate: 0,
        }
        for (let i = 0; i < messages.length; i++) {
            if (i > 0) {
                const prevMessage = messages[i - 1]
                params = getParams(prevMessage as HTMLElement)
            }
            const message = messages[i] as HTMLElement
            message.style.transform = getTransform(params)
        }
    }

    const closeMessage = (message: HTMLElement) => {
        message.classList.add("removing")
        setTimeout(() => {
            message.remove()
            updateMessagePosition()
        }, 200)
    }

    const getParams = (message: HTMLElement): ParamsType => {
        const height = message.clientHeight
        let { transform } = message.style
        transform = transform.substring(11, transform.length - 1)
        const translate = parseInt(transform, 10)

        return { height, translate }
    }

    const getTransform = (params: ParamsType) => (
        `translateY(${params.height + params.translate + 7}px)`
    )


    const messages = layout.querySelectorAll(BalloonMessageWrapper)
    const lastMessage = messages.length ? messages[messages.length - 1] : null

    let params: ParamsType = {
        height: 0,
        translate: 0,
    }
    if (lastMessage) {
        params = getParams(lastMessage as HTMLElement)
    }

    const emptyDiv = document.createElement("div")
    ReactDOM.render(
        (
            <BalloonMessageWrapper style={{ transform: getTransform(params) }}>
                <Message>
                    <MessageBody>{text}</MessageBody>
                    <MessageClose>
                        <CrossIcon />
                    </MessageClose>
                </Message>
            </BalloonMessageWrapper>
        ),
        emptyDiv,
    )

    const newMessage = emptyDiv.firstChild as HTMLElement
    newMessage.querySelector(MessageClose).addEventListener("click", (e) => {
        const target = e.target as HTMLElement
        const message = target.closest(BalloonMessageWrapper)
        closeMessage(message as HTMLElement)
    })
    layout.append(newMessage)

    setTimeout(() => {
        newMessage.classList.add("show")
    }, 100)
    setTimeout(() => {
        closeMessage(newMessage)
    }, 7000)
}
